import React from "react"
import PropTypes from "prop-types"

// components
import {
    QuicklinkWidget as StyledQuicklinkWidget,
    Widget,
} from "quorumdesign"

const QuicklinkWidget = ({
    editForm,
    editing,
    headerIcons,
    isExternalLink,
    segueToUrl,
    text,
    type,
    url,
    widget,
    widgetKey,
}) => (
    <Widget
        editing={editing}
        gradientHeader={editing}
        headerIcons={headerIcons}
        id={widgetKey && `widget-${widgetKey}`}
        noBorder
        noHeader
        widget={
            <StyledQuicklinkWidget
                editForm={editForm}
                editing={editing}
                icon={
                    type === DjangIO.app.widgets.types.QuicklinkType.custom.value
                        ? 'link'
                        : 'plus'
                }
                id={widgetKey && `widget-${widgetKey}`}
                isExternal={isExternalLink}
                segueToUrl={segueToUrl}
                text={text}
                type={type}
                url={url}
                widget={widget}
            />
        }
    />
)

QuicklinkWidget.defaultProps = {}

QuicklinkWidget.propTypes = {
    editForm: PropTypes.bool,
    editing: PropTypes.bool,
    headerIcons: PropTypes.array,
    isExternal: PropTypes.bool,
    segueToUrl: PropTypes.func,
    text: PropTypes.string,
    type: PropTypes.number,
    url: PropTypes.string,
    widget: PropTypes.object,
    widgetKey: PropTypes.string,
}

export default QuicklinkWidget
